// Auth0 Configuration for ProCogia Telecom AI Agent
// Uses custom domain (login.procogia.ai) for branded login experience

const isProduction = typeof window !== 'undefined' && window.location.hostname === 'procogia-telecom-ai-agent.procogia.ai';
const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';

// Custom domain configuration for branded login experience
const CUSTOM_DOMAIN = 'login.procogia.ai';
const DEFAULT_DOMAIN = 'dev-n7rk0rh3lr8yot4u.ca.auth0.com';

// Use custom domain for production - verified to work correctly
const AUTH0_DOMAIN = CUSTOM_DOMAIN;

export const auth0Config = {
  domain: AUTH0_DOMAIN,
  clientId: 'm9mqRYRXS75BOybSgDqW7RUCtsd6evqn',

  // Always use /callback for redirect URI - it's properly configured in Auth0
  redirectUri: typeof window !== 'undefined' ? `${window.location.origin}/callback` : '',

  logoutUri: typeof window !== 'undefined' ? window.location.origin : '',
  scope: 'openid profile email',

  // Enhanced Auth0 configuration for branded experience
  audience: undefined, // Add if you have an API audience
  responseType: 'code',

  // Cache configuration
  cacheLocation: 'localstorage' as const,
  useRefreshTokens: true, // Enable refresh tokens for better UX

  // Additional parameters for custom branding
  authorizationParams: {
    scope: 'openid profile email',
    redirect_uri: typeof window !== 'undefined' ? `${window.location.origin}/callback` : '',
  },
};

export default auth0Config; 